<script lang="ts" setup>
import YouCanDoThisCard from '../YouCanDoThis/YouCanDoThisCard.vue';

defineProps<{
  imageNumber: InstanceType<typeof YouCanDoThisCard>['$props']['imageNumber'];
}>();
</script>

<template>
  <YouCanDoThisCard :image-number="imageNumber">
    <template #titleText>
      一人ひとりの希望に沿った<span
        :class="$style['youCanDoThisTitleText--accent']"
        >最適な住宅購入の資金計画相談</span
      >
    </template>
    <template #detail>
      オカネコでは、一方的な説明はせず、まずはお客様の状況をしっかりとヒアリングし、ライフプランシミュレーションを作成します。これを元に、現状の家計や今後の人生設計に基づいて最適な住宅購入のための資金計画をご提案します。住宅購入のための資金繰りや住宅ローンの選び方について、あなたの理想や目的に応じた的確なアドバイスを行います。
    </template>
  </YouCanDoThisCard>
</template>

<style lang="scss" module>
.youCanDoThisTitleText {
  &--accent {
    color: $color-text-and-object-accent-primary;
  }
}
</style>
